/**
 * Image Slider
 */

/* eslint-disable */
import owl from 'owl.carousel';
import baguetteBox from '../../../../node_modules/baguettebox.js/dist/baguettebox';

const imageCarousel = {
    cfg: {

        slider: '.js-imageCarousel',
        carouselOptions: {
            overlayBackgroundColor: 'rgba(255,255,255,0.8)',
        },
        sliderOptions: {
            // pullDrag: true,
            margin: 10,
            loop: false,
            // responsiveClass:true,
            touchDrag: true,
            mouseDrag: true,
            autoplay:false,
            // smartSpeed : 1500,
            autoplayHoverPause:true,
            navElement:'div',
            navClass: [ 'swiper-button-prev','swiper-button-next'],
            navText:[
                '<span class="a-icon  a-icon--iconChevronLeft"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"></path></svg></span>',
                '<span class="a-icon  a-icon--iconChevronRight"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"></path></svg></span>'],
            //videoWidth: 600,
            responsive: {
            0: {
                items: 2,
                nav: true,
                dots: false
            },
            700: {
                items: 3,
                nav: true,
                dots: false
            },
            1000: {
                items: 4,
                nav: true,
                dots: false
            },
            1200: {
                items: 4,
                nav: true,
                dots: false
            }
            }
        }
    },

    init() {

        const gallery = document.querySelector('.js-imageCarousel');
        if (gallery) {
            baguetteBox.run('.js-imageCarousel', this.cfg.carouselOptions);
        }

        let $owl = $(this.cfg.slider).owlCarousel( this.cfg.sliderOptions);

        setTimeout(() => {
            $owl.trigger('refresh.owl.carousel');
        }, 500);
    }
};
/* eslint-enable */
export default imageCarousel;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/imageCarousel/_script.js